import styled from "styled-components";

export const SectionTitle = styled.h2`
  font-size: 18px;
  font-weight: 700;
  margin: 0 0 20px 0;
  color: #000000;
`;

export const Card = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.08);

  @media (max-width: 640px) {
    padding: 16px;
    border-radius: 8px;
  }
`;

export const Row = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  align-items: flex-end;
  margin-bottom: 16px;

  @media (max-width: 640px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const FilterRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 10px;
  margin-bottom: 16px;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const Input = styled.input`
  padding: 9px 14px;
  border: 1px solid #d0d0d0;
  border-radius: 8px;
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  outline: none;
  box-sizing: border-box;
  width: 100%;
  &:focus { border-color: #000000; }

  &[type="date"],
  &[type="time"] {
    -webkit-appearance: none;
    appearance: none;
    display: block;
    min-width: 0;
    min-height: 38px;
    background: #ffffff;
    color: #111111;
    text-align: left;
  }

  &::-webkit-date-and-time-value {
    text-align: left;
  }

  @media (max-width: 700px) {
    font-size: 16px;
  }
`;

export const Select = styled.select`
  padding: 9px 14px;
  border: 1px solid #d0d0d0;
  border-radius: 8px;
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  outline: none;
  background: #ffffff;
  cursor: pointer;
  box-sizing: border-box;
  width: 100%;
  &:focus { border-color: #000000; }
  @media (max-width: 700px) {
    font-size: 16px;
  }
`;

export const Button = styled.button<{ variant?: 'primary' | 'secondary' | 'danger' }>`
  padding: 9px 20px;
  border-radius: 8px;
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.15s ease;
  border: none;
  white-space: nowrap;
  &:hover { opacity: 0.85; }
  &:disabled { opacity: 0.4; cursor: not-allowed; }
  ${({ variant }) => {
    if (variant === 'secondary') return `background: #f0f0f0; color: #000000;`;
    if (variant === 'danger') return `background: #dc2626; color: #ffffff;`;
    return `background: #000000; color: #ffffff;`;
  }}
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;

  @media (max-width: 960px) {
    thead {
      display: none;
    }

    tr {
      display: block;
      padding: 10px 0;
      border-bottom: 1px solid #eee;
    }

    td {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      padding: 4px 0;
      border-bottom: none;
      text-align: right;
      white-space: normal !important;
      max-width: none !important;
      overflow: visible !important;
      overflow-wrap: anywhere;
    }

    td[data-label]::before {
      content: attr(data-label);
      flex-shrink: 0;
      font-size: 12px;
      font-weight: 600;
      color: #888;
      text-align: left;
    }

    td:not([data-label]) {
      display: block;
      text-align: left;
    }
  }
`;

export const Th = styled.th`
  text-align: left;
  padding: 10px 12px;
  background: #f5f5f5;
  font-weight: 600;
  color: #444;
  border-bottom: 1px solid #e0e0e0;
  white-space: nowrap;
`;

export const Td = styled.td`
  padding: 10px 12px;
  border-bottom: 1px solid #f0f0f0;
  color: #222;
  vertical-align: middle;
`;

export const Tr = styled.tr`
  cursor: pointer;
  &:hover { background: #fafafa; }
`;

export const Badge = styled.span<{ color?: string }>`
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  background: ${({ color }) => color || '#e5d8cb'};
  color: #000000;
  white-space: nowrap;
`;

export const Textarea = styled.textarea`
  padding: 9px 14px;
  border: 1px solid #d0d0d0;
  border-radius: 8px;
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  outline: none;
  width: 100%;
  min-height: 100px;
  resize: vertical;
  box-sizing: border-box;
  &:focus { border-color: #000000; }
  @media (max-width: 700px) {
    font-size: 16px;
  }
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const Label = styled.label`
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #555;
  margin-bottom: 4px;
`;

export const FormField = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StatusText = styled.p<{ success?: boolean }>`
  font-size: 13px;
  color: ${({ success }) => (success ? '#16a34a' : '#dc2626')};
  margin: 8px 0 0 0;
`;

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 16px;
  box-sizing: border-box;
`;

export const Modal = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 28px;
  width: 100%;
  max-width: 560px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 8px 32px rgba(0,0,0,0.2);

  @media (max-width: 640px) {
    padding: 20px 16px;
    border-radius: 8px;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
`;

export const ModalTitle = styled.h3`
  font-size: 16px;
  font-weight: 700;
  margin: 0;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #666;
  padding: 0 4px;
  &:hover { color: #000; }
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 40px;
  color: #888;
  font-size: 14px;
`;

export const StatCards = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 12px;
  margin-bottom: 24px;

  @media (max-width: 640px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }
`;

export const StatCard = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 16px 20px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.08);

  @media (max-width: 640px) {
    padding: 14px;
    border-radius: 8px;
  }
`;

export const StatValue = styled.div`
  font-size: 28px;
  font-weight: 700;
  color: #000000;

  @media (max-width: 640px) {
    font-size: 22px;
  }
`;

export const StatLabel = styled.div`
  font-size: 12px;
  color: #888;
  margin-top: 4px;
`;
